<ng-container *transloco="let t">
  <ng-container [formGroup]="editForm">
    <div class="row" formGroupName="config">
      <div class="col-5">
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="checkStrategy">{{t('check-strategy.label')}}</mat-label>
          <mat-select formControlName="checkStrategy">
            <mat-option *ngFor="let e of checkStrategies" [value]="e">{{t('check-strategy.'
              + e)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-7">
        <ng-container *ngFor="let enablingIdCtl of getEnablingIdsControls() as controls; index as i; last as isLast"
          formArrayName="enablingIds">
          <div class="row">
            <div class="col">
              <mat-form-field class="w-100" appearance="fill" [formGroupName]="i">
                <mat-label for="name">{{t('check-enablings-edit.enabling')}}</mat-label>
                <mat-select [formControl]="enablingIdCtl">
                  <mat-option *ngFor="let e of enablings$ | async" [value]="e.id">{{e.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-2" *ngIf="mode === 'edit'">
              <mat-icon class="pointer" *ngIf="controls.length > 1" (click)="removeEnabling(i)" color="warn">delete
              </mat-icon>
              <mat-icon class="pointer" *ngIf="isLast" (click)="addEnabling(editForm)" color="accent">add</mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

  </ng-container>
</ng-container>
